import React from 'react';

import {
  CourseContainer,
  SkillContainer,
  SkillHeader,
  ChallengeSticker,
  ExerciseStickerContent,
  ExercisesContainer,
  ChallengeName,
  ChallengeEmptyText,
  ExerciseLink,
  ExerciseLanguageContent,
  LevelsHeader,
} from './styles';

export default function CourseTab({ profile }) {
  const { courses } = profile;

  const renderCourse = (course) => {
    return (
      <ExerciseLink to={`/courses/${course.id}`} key={course.id}>
        <ChallengeSticker key={course.name} image={course.image}>
          <LevelsHeader>
            {course.completedLevels}/{course.totalLevels} Levels Completed
          </LevelsHeader>
          <ExerciseStickerContent>
            <ChallengeName>{course.name}</ChallengeName>
            {course.languagesUsed.length ? (
              <ExerciseLanguageContent>
                Languages Used:&nbsp;
                {course.languagesUsed.map((language, index) => (
                  <span key={course.id + index}>{(index ? ', ' : '') + language}</span>
                ))}
              </ExerciseLanguageContent>
            ) : null}
            {course.completedLanguages.length ? (
              <ExerciseLanguageContent>
                Languages Completed:&nbsp;
                {course.completedLanguages.map((language, index) => (
                  <span key={course.id + index}>{(index ? ', ' : '') + language}</span>
                ))}
              </ExerciseLanguageContent>
            ) : null}
          </ExerciseStickerContent>
        </ChallengeSticker>
      </ExerciseLink>
    );
  };

  return (
    <CourseContainer>
      {Object.keys(courses)?.map((course) => (
        <SkillContainer height={'auto'} key={`course${course}`}>
          <SkillHeader>{course} Courses</SkillHeader>
          <ExercisesContainer>
            {courses[course].length > 0 ? (
              courses[course].map(renderCourse)
            ) : (
              <ChallengeEmptyText>
                {course === 'purchased'
                  ? 'You have not purchased any course yet'
                  : course === 'free'
                    ? 'There are no free courses available'
                    : 'There are no other paid courses available'}
              </ChallengeEmptyText>
            )}
          </ExercisesContainer>
        </SkillContainer>
      ))}
    </CourseContainer>
  );
}
